// extracted by mini-css-extract-plugin
export default {"root":"KeywordFilter_root__K84Z0","field":"KeywordFilter_field__14MIM","fieldPlain":"KeywordFilter_fieldPlain__Ls9on"};